import mascaras from '@/util/mascaras'
import util from '@/util'
import mensagens from '@/util/mensagens'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import constants from '@/util/constants'
import ConfirmacaoDados from '@/components/layout/confirmacaoDados/ConfirmacaoDados.vue'

export default {
  name: 'Endereco',
  components: {
    spinnerProcessando,
    ConfirmacaoDados
  },
  model: {
    prop: 'endereco',
    event: 'update'
  },
  props: {
    listaDeErros: {
      type: [Array, Object],
      required: false
    },
    endereco: {
      type: Object,
      required: true
    },
    flagsDeControle: {
      type: Object,
      required: true
    },
    consultaUnidadesFederativas: {
      type: Function,
      required: true
    },
    obrigatorio: {
      type: Object,
      default: () => ({
        cep: false,
        endereco: false,
        numero: false,
        complemento: false,
        bairro: false,
        cidade: false,
        uf: false
      })
    }

  },
  inject: ['viaCep'],
  computed: {
    mascaraCep () {
      return mascaras.mascarasParaCampos.cep
    },
    formulario: {
      get () {
        return this.endereco
      },
      set (novoValor) {
        this.$emit('input', novoValor)
      }
    },
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    }
  },

  data: () => {
    return {
      mostrarModalConfirmacao: false,
      combosUnidadesFederativas: [],
      timeOutDigitacaoNocombo: null,
      novosDados: {},
      mapeamentoCampos: {
        cep: 'CEP',
        endereco: 'Endereço',
        bairro: 'Bairro',
        cidade: 'Cidade',
        numero: 'Número',
        complemento: 'Complemento',
        uf: 'Estado'
      }
    }
  },
  mounted () {
    this.obterUnidadesFederativas()
  },
  methods: {
    mapearUnidadeFederativa (unidadeFederativa) {
      if (!unidadeFederativa) {
        return
      }
      let codigoUnidadeFederativa = unidadeFederativa.code ? unidadeFederativa.code : unidadeFederativa

      const uf = this.combosUnidadesFederativas.find(unidadeFederativa => unidadeFederativa.code === codigoUnidadeFederativa)
      return { code: uf?.code, label: uf?.label }
    },
    async buscarEndereco (valor) {
      const cep = valor.replace(/\D/g, '')
      if (cep.length !== 8) return

      try {
        this.definirFlagCarregandoDados(true, 'Buscando endereço...')
        const resposta = await this.viaCep.buscarCEP(cep)
        if (!resposta) {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
          this.definirFlagCarregandoDados(false, '')
          return
        }
        const novosDados = {
          endereco: resposta.logradouro,
          bairro: resposta.bairro,
          cidade: resposta.municipio ?? resposta.localidade,
          complemento: resposta.complemento,
          uf: this.mapearUnidadeFederativa(resposta.uf ?? resposta.estado),
          ibge: resposta.ibge
        }
        this.sincronizarDados(novosDados)
        this.$emit('atualizarDados', this.formulario)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCancelandoContrato)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },
    fecharModal () {
      this.mostrarModalConfirmacao = false
    },
    substituirDados (novosDados) {
      this.preencherFormulario(novosDados)
      this.mostrarModalConfirmacao = false
    },

    sincronizarDados (dados) {
      const informacoesDiferentes = JSON.stringify(this.formulario) !== JSON.stringify(dados)
      this.novosDados = dados
      if (informacoesDiferentes && !util.valorVazio(this.formulario.endereco)) {
        this.mostrarModalConfirmacao = true
        return
      }

      this.preencherFormulario(dados)
    },
    preencherFormulario (dados) {
      this.formulario.endereco = dados.endereco
      this.formulario.bairro = dados.bairro
      this.formulario.cidade = dados.cidade
      this.formulario.complemento = dados.complemento
      this.formulario.ibge = dados.ibge
      this.formulario.uf = this.mapearUnidadeFederativa(dados.uf)
    },
    eventoDigitarBuscaPorUnidadeFederativa (valorDigitadoParaBusca, callbackFlagCarregamento) {
      clearTimeout(this.timeOutDigitacaoNocombo)
      let referenciaObjetoDaView = this

      this.timeOutDigitacaoNocombo = setTimeout(function () {
        referenciaObjetoDaView.obterUnidadesFederativas(valorDigitadoParaBusca, callbackFlagCarregamento)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async obterUnidadesFederativas (valorDigitadoParaBusca, callbackFlagCarregamento) {
      if (!util.valorEhNulo(callbackFlagCarregamento)) {
        callbackFlagCarregamento = true
      }
      const resposta = await this.consultaUnidadesFederativas(valorDigitadoParaBusca, callbackFlagCarregamento)
      const listaUnidadesFederativas = resposta
      this.combosUnidadesFederativas = listaUnidadesFederativas.map(registro => {
        return { label: registro.nome, code: registro.id }
      })
      callbackFlagCarregamento = false
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
